import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import { Order } from "@/types/types";

import { EmailState } from "@/types/email";

import { emailApi } from "./email.api";

const initialState: EmailState = {
	email: [],
	sortingEmail: {
		sortBy: "createdAt",
		sortOrder: Order.ASC,
	},
	meta: {
		page: 1,
		limit: 15,
		itemCount: 15,
		pageCount: 1,
		hasPreviousPage: false,
		hasNextPage: false,
	},
};

export const emailSlice = createSlice({
	name: "email",
	initialState,
	reducers: {
		setEmailSorting: (state, { payload }) => {
			if (
				state.sortingEmail.sortOrder === Order.DESC &&
				payload.sortOrder === Order.ASC &&
				payload.sortBy === state.sortingEmail.sortBy
			) {
				payload.sortBy = initialState.sortingEmail.sortBy;
				payload.sortOrder = initialState.sortingEmail.sortOrder;
			}

			state.sortingEmail = payload;
		},
	},
	extraReducers: (builder) => {
		builder.addMatcher(emailApi.endpoints.getEmails.matchFulfilled, (state, { payload }) => {
			state.email = payload.data;
			state.meta = payload.meta;
		});
	},
});

export const { setEmailSorting } = emailSlice.actions;
export const emailReducer = emailSlice.reducer;
export const emailSelector = (state: RootState) => state[emailSlice.name];
